
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admission-notification",
      function () {
        return require("private-next-pages/admission-notification.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admission-notification"])
      });
    }
  